import { GridRowClassNameParams, GridValidRowModel } from '@mui/x-data-grid-pro';
import { Classnames } from '@cbridge-utils/mui-theme';

const getZebraClassName = ({ indexRelativeToCurrentPage }: GridRowClassNameParams) =>
  (indexRelativeToCurrentPage % 2 === 0 ? Classnames.GRID_ODD_ROW : '');

export const composeZebraRowClassName = <T extends GridValidRowModel>(
  custom?: (params: GridRowClassNameParams<T>) => string,
) =>
  (params: GridRowClassNameParams<T>): string => {
    const zebra = getZebraClassName(params);
    const userClass = custom?.(params) ?? '';
    return userClass ? `${zebra} ${userClass}` : zebra;
  };
